import React, { useEffect, useState } from 'react';
import { func, number, object } from 'prop-types';
import { currencyFormatter } from '@magalu/stereo-ui-utils';
import { Input, Flex, RangeSlider, Text } from '../../atoms';
import moneyMask from '../../utils/moneyMask';
import { Wrapper, InputLabel, InputValuesWrapper, SliderInputWrapper, ApplyButton } from './price-range.styles';
import { isMaxValidValue, isMinValidValue } from '../../utils';

const PriceRange = ({
  item,
  onApply,
  min,
  max,
  initialMin,
  initialMax
}) => {
  const [minValue, setMinValue] = useState();
  const [maxValue, setMaxValue] = useState();
  const [displayMin, setDisplayMin] = useState();
  const [displayMax, setDisplayMax] = useState();
  useEffect(() => {
    setMinValue(initialMin * 100);
    setDisplayMin(moneyMask(initialMin * 100).currency);
  }, [initialMin]);
  useEffect(() => {
    setMaxValue(initialMax * 100);
    setDisplayMax(moneyMask(initialMax * 100).currency);
  }, [initialMax]);
  const minDiv = minValue / 100;
  const maxDiv = maxValue / 100;
  const applyBtnDisabled = minDiv === initialMin && maxDiv === initialMax || !isMinValidValue(minDiv, maxDiv, min, max) || !isMaxValidValue(maxDiv, minDiv, min, max);

  const handleChangeMax = (newValue, isRange = true) => {
    const {
      amount,
      currency
    } = moneyMask(isRange ? newValue * 100 : newValue);
    setMaxValue(amount);
    setDisplayMax(currency);
  };

  const handleChangeMin = (newValue, isRange = true) => {
    const {
      amount,
      currency
    } = moneyMask(isRange ? newValue * 100 : newValue);
    setMinValue(amount);
    setDisplayMin(currency);
  };

  const handleRangeChange = ({
    currentMax,
    currentMin
  }) => {
    handleChangeMax(currentMax);
    handleChangeMin(currentMin);
  };

  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-testid": "price"
  }, /*#__PURE__*/React.createElement(InputValuesWrapper, null, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/React.createElement(InputLabel, {
    "data-testid": "price-range-min-label",
    fontSize: 0
  }, /*#__PURE__*/React.createElement(Text, {
    color: "inherit"
  }, "M\xEDnimo:"), /*#__PURE__*/React.createElement(Text, {
    color: "inherit"
  }, currencyFormatter({
    value: min * 100,
    rightFilling: true
  }))), /*#__PURE__*/React.createElement(Input, {
    "data-testid": "price-range-min-input",
    value: displayMin,
    placeholder: "Ex: R$ 250,00",
    maxLength: 15,
    onChange: e => handleChangeMin(e.target.value, false)
  })), /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/React.createElement(InputLabel, {
    "data-testid": "price-range-max-label",
    fontSize: 0
  }, /*#__PURE__*/React.createElement(Text, {
    color: "inherit"
  }, "M\xE1ximo:"), /*#__PURE__*/React.createElement(Text, {
    color: "inherit"
  }, currencyFormatter({
    value: max * 100,
    rightFilling: true
  }))), /*#__PURE__*/React.createElement(Input, {
    "data-testid": "price-range-max-input",
    value: displayMax,
    placeholder: "Ex: R$ 500,00",
    maxLength: 15,
    onChange: e => handleChangeMax(e.target.value, false)
  }))), /*#__PURE__*/React.createElement(SliderInputWrapper, null, /*#__PURE__*/React.createElement(RangeSlider, {
    maxAllowed: parseFloat(max),
    minAllowed: parseFloat(min),
    currentMax: parseFloat(maxDiv),
    currentMin: parseFloat(minDiv),
    onChange: handleRangeChange
  })), /*#__PURE__*/React.createElement(ApplyButton, {
    "data-testid": "price-range-apply-btn",
    full: true,
    onClick: event => onApply(event, {
      min: parseFloat(minValue / 100),
      max: parseFloat(maxValue / 100)
    }, item),
    disabled: applyBtnDisabled
  }, "Aplicar filtro"));
};

PriceRange.defaultProps = {
  item: {},
  onApply: () => {}
};
process.env.NODE_ENV !== "production" ? PriceRange.propTypes = {
  item: object,
  onApply: func,
  min: number.isRequired,
  max: number.isRequired,
  initialMin: number,
  initialMax: number
} : void 0;
export default PriceRange;